import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IhmSelectAllCheckboxComponent } from './ihm-select-all-checkbox.component';

@NgModule({
  imports: [
    // common modules
    CommonModule,
    ReactiveFormsModule,

    // material modules
    MatCheckboxModule
  ],
  declarations: [IhmSelectAllCheckboxComponent],
  exports: [IhmSelectAllCheckboxComponent]
})
export class IhmSelectAllCheckboxModule {}
